import React, { useState } from "react";
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { GPAP_Button_light } from "../../../../gpap-lib/Button_Collection";
import { experiment_get, experiments_post } from "../../../service/apis";
import { validate } from './service/Validate'
import { parseTsvFile } from './service/ParseTsvFile'
import ExperimentBatchTsv from './components/ExperimentBatchTsv'
import ExperimentBatchTable from './components/ExperimentBatchTable'


import auth from '../../../service/Auth';
import ExperimentBatchResults from "./components/ExperimentBatchResults";


const config = window.config;


const ExperimentBatchEdition =()=>{

    const [experimentFields, setExperimentFields] = useState([]);
    const [step, setStep] = useState(1);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [experimentErrors, setExperimentErrors] = useState({});
    const [experimentUpdated, setExperimentUpdated] = useState({});

    const downloadTsvTemplate = (event) => {
        const header = ["ExperimentID", ...experimentFields];
        const element = document.createElement("a");
        const file = new Blob([header.join(',') + "\n"], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "experimentBatchEdition.csv";
        document.body.appendChild(element);
        element.click();
    };


    const uploadTsv = async (data) => { 
        // 1. Parse TSV File
        setStep(12);
        const tsvContents = await parseTsvFile(data);
        // 2. Update States
        setColumns(tsvContents.columns);
        setRows(tsvContents.rows);
        setStep(2);
    }

    const experimentExists = async(experimentId) => {
        // Check is an experiment exists
        const response = await experiment_get(auth.getToken(),config.api_endpoint, experimentId);
        return response.ok;
    }

    const updateExperiments = async() => {
        setStep(23);
        let errors = [];
        let updated = [];
        for (let row of rows) {
            // 1. Validate Experiment ID
            let experimentId = row["ExperimentID"];
            let expExists = await experimentExists(experimentId);
            if (! expExists){
                errors.push({id:row["id"], experiment: experimentId, reason: "Experiment does not exists!"})
                continue;
            }
            // 2. Validate Fields
            let validation = await validate(row);
            if (Object.keys(validation).length !== 0) {
                validation["id"] = row["id"];
                errors.push(validation);
                continue;
            } 
            // 3. Create Body Post
            let body = {};
            for (let key in row) {
                if (key === "in_platform" || key === "processed") {
                    if (row[key].toLowerCase() === "true") body[key] = true;
                    else body[key] = false;
                }
                else if(key !== "id" && key !== "ExperimentID" && ! key.startsWith("Current")) {
                    if (key === 'LocalExperimentID') body["Submitter_ID"] = row[key];
                    body[key] = row[key];
                }
            }
            // 4. Perform Post
            const response = await experiments_post(JSON.stringify(body),auth.getToken(),config.api_endpoint,experimentId);
            if (response.status == 200) {
                body["Experiment"] = experimentId;
                body["id"] = row["id"];
                updated.push(body);
            } else {
                errors.push({id:row["id"], experiment: experimentId, reason: response.statusText});
            }
        }
        // 5. Experiment Errors
        const errorsHeader = [
            {field: 'id', headerName: 'ID', width: 70, hide: true },
            {field:"experiment", headerName: "Experiment", width: 150},
            {field:"reason", headerName: "Reason", width: 450, cellClassName: 'red-reason'}
        ]
        setExperimentErrors({columns: errorsHeader,rows:errors});
        // 6. Experiments Updated
        if (updated.length > 0) {
            const updatedHeader = Object.keys(updated[0]).map((key) => ({field:key, headerName: key, width:200})).reverse();
            updatedHeader.find((item) => item.field === "id")["hide"] = true;
            setExperimentUpdated({columns: updatedHeader, rows: updated});
        } else {
            setExperimentUpdated({columns: [], rows: []});
        }
    
        setStep(3);
    }

    const ExperimentBatchEditionHeader = () => {
        return(
            <div>
                <Typography variant={"h5"} align={"center"}> Experiment Batch Edition </Typography>
                <GPAP_Button_light href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>
            </div>
        );
    }

    const LoadingProcess = (props) => {
        return(
            <Box sx={{ width: '100%' }}>
                <Typography variant="body1">{props.message}</Typography>
                <LinearProgress />
            </Box>
        )
    }

    if (step === 1){
        /* Step 1 TSV Experiment Batch Upload */
        return (
            <div className={"mainContent"}>
                <ExperimentBatchEditionHeader/>
                <ExperimentBatchTsv
                    fields={experimentFields}
                    setFields={setExperimentFields}
                    downloadTsvTemplate={downloadTsvTemplate}
                    uploadTsv={uploadTsv}
                />
            </div>
        );
    } else if(step === 12){
        /* Step 12 Loading TSV File */
        return (
            <div className={"mainContent"}>
                <ExperimentBatchEditionHeader/>
                <LoadingProcess message={"Loading TSV File..."}/>
            </div>
        );
    } else if(step === 2){
        /* Step 2 Show load data and confirmation */
        return (
            <div className={"mainContent"}>
                <ExperimentBatchEditionHeader/>
                <ExperimentBatchTable 
                    uploadTsv={uploadTsv}
                    updateExperiments={updateExperiments}
                    rows={rows}
                    columns={columns}
                    pageSize={100}
                />  
            </div>
        );
    } else if(step === 23){
        /* Step 12 Loading TSV File */
        return (
            <div className={"mainContent"}>
                <ExperimentBatchEditionHeader/>
                <LoadingProcess message={"Updating Database..."}/>
            </div>
        );
    } else if(step === 3){
        /* Step 3 Experiment Update Results */
        return (
            <div className={"mainContent"}>
                <ExperimentBatchEditionHeader/>
                <ExperimentBatchResults
                        experimentUpdated={experimentUpdated}
                        experimentErrors={experimentErrors}
                        pageSize={100}
                />
            </div>
        );
    }
}

export default ExperimentBatchEdition;
